export default "__VITE_ASSET__CfJT2Yao__"